<div *ngIf="showcookiePopup" [ngClass]="{'cookie-consent': true,'show': !isConsentGiven}">
    <div class="cookie-message">
        <p>How would you like to proceed?</p>
        <div class="cookies-button">
        <button (click)="acceptCookies()">Continue With Web</button>
        <button (click)="navigate()">Continue With Mobile App</button>
        </div>
    </div>
</div>